/**
 * 密码规则统一常量（前端）
 * 必须与 backend/src/modules/auth/password-rules.ts 保持一致
 */

export const PASSWORD_RULES = {
  minLength: 8,
  maxLength: 20,
  requireLetter: true,
  requireDigit: true,
} as const;

/** 规则提示文案（表单 placeholder 与错误文案） */
export const PASSWORD_HINT = `请设置 ${PASSWORD_RULES.minLength}-${PASSWORD_RULES.maxLength} 位密码，包含字母与数字`;

/**
 * 校验密码
 * @returns 通过返回 null，不通过返回错误文案
 */
export function validatePassword(password: string | undefined | null): string | null {
  if (!password) return '请设置密码';
  if (password.length < PASSWORD_RULES.minLength || password.length > PASSWORD_RULES.maxLength) {
    return PASSWORD_HINT;
  }
  if (PASSWORD_RULES.requireLetter && !/[a-zA-Z]/.test(password)) return PASSWORD_HINT;
  if (PASSWORD_RULES.requireDigit && !/[0-9]/.test(password)) return PASSWORD_HINT;
  return null;
}

/**
 * 计算密码强度 0-100
 */
export function calcPasswordStrength(password: string): number {
  if (!password) return 0;
  let s = 0;
  if (password.length >= PASSWORD_RULES.minLength) s += 33;
  if (password.length >= 12) s += 33;
  if (/[a-zA-Z]/.test(password) && /[0-9]/.test(password)) s += 34;
  return s;
}
